export default "__VITE_ASSET__CMHzi_Jr__"